import BgColorType from "@/lib/types/layout/containers/BgColor.type";
import { CSSProperties, HTMLAttributes, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  bgColor?: BgColorType;
  className?: HTMLAttributes<HTMLTableCellElement>["className"];
  colSpan?: number;
  textAlign?: CSSProperties["textAlign"];
  style?: CSSProperties;
  wrap?: boolean;
}>;

export default function TD({
  children,
  className,
  colSpan,
  textAlign,
  bgColor,
  style,
  wrap,
}: Props) {
  const styles: CSSProperties = {
    backgroundColor: bgColor ? `var(--color-background-${bgColor})` : undefined,
    border: "1px solid var(--color-border-primary)",
    fontSize: "var(--font-size-body-sm)",
    padding: "var(--spacing-md)",
    textAlign: textAlign || "start",
    whiteSpace: wrap ? "normal" : "nowrap",
    ...(wrap && {
      wordBreak: "break-word",
      overflowWrap: "break-word",
    }),
    ...style,
  };

  return (
    <td className={className} colSpan={colSpan} style={styles}>
      {children}
    </td>
  );
}
